import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { createRoot } from 'react-dom/client'
import api from './api'
import App, { store } from './app'
import { router } from './appRouter'
import './assets/styles/global.scss'
import { registerAtlasTabVisibility } from './helpers/atlasTabVisibility'
import { registerChunkRecovery } from './helpers/chunkRecovery'
import { getCommittedLocationKey } from './helpers/committedLocation'
import { isSpeculativeImportInFlight, registerRoutePreloading } from './helpers/routePreload'
import { registerServiceWorkerNavigation } from './helpers/serviceWorkerNavigation'
import { restoreOfflineSnapshot } from './redux/offlineSnapshotMiddleware'
import * as serviceWorker from './serviceWorker'

// Before render, so a route chunk that went missing in a deploy is recovered rather than
// surfacing as the router error page.
registerChunkRecovery(
  () => isSpeculativeImportInFlight() && router.state.location.key === getCommittedLocationKey(),
)
registerServiceWorkerNavigation((path) => router.navigate(path))
registerRoutePreloading(router.routes)
registerAtlasTabVisibility()

const container = document.getElementById('root')
const root = createRoot(container)

/** The snapshot usually reads in a few ms; never hold the first paint hostage to a slow disk. */
const SNAPSHOT_RESTORE_BUDGET_MS = 400

const renderApp = () =>
  root.render(
    <DndProvider backend={HTML5Backend}>
      <App />
    </DndProvider>,
  )

void Promise.race([
  restoreOfflineSnapshot(api, store.dispatch),
  new Promise((resolve) => setTimeout(resolve, SNAPSHOT_RESTORE_BUDGET_MS)),
]).finally(renderApp)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA

void serviceWorker.register()
